
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("99rcJ", function(module, exports) {

$parcel$export(module.exports, "CalendarsLink", () => $544e89ef74bbdb03$export$5bc2ad8fe7e5e700);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $3gadb = parcelRequire("3gadb");

var $8DN9t = parcelRequire("8DN9t");

var $7x0As = parcelRequire("7x0As");

var $1NBp8 = parcelRequire("1NBp8");

var $luv00 = parcelRequire("luv00");

var $61vzn = parcelRequire("61vzn");

var $ep3mz = parcelRequire("ep3mz");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $1ytiN = parcelRequire("1ytiN");

var $dPJCf = parcelRequire("dPJCf");
const $544e89ef74bbdb03$export$5bc2ad8fe7e5e700 = (props)=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    /**
   * showTCNav:
   * - Premium -> true, TC is a premium feature
   * - Standard -> true, iff user is Org/Site Admin, otherwise, false (https://hello.atlassian.net/wiki/spaces/CE2/pages/3031965072/ETC+Standard+P18N+Technical+Spec)
   * - Free -> true, TC upsell to all Free users (https://hello.atlassian.net/wiki/spaces/CE2/pages/2906634153/ETC+P18N+Technical+Spec)
   */ const showTCNav = edition === (0, $euL71.ConfluenceEdition).STANDARD ? isSiteAdmin : true;
    return showTCNav ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($544e89ef74bbdb03$var$CalendarsLinkInner, props) : null;
};
const $544e89ef74bbdb03$var$CalendarsLinkInner = ({ onClick: onClick })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isSelected = (0, $dPJCf.useRouteName)($544e89ef74bbdb03$var$isOnSCalendarsRoute);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $544e89ef74bbdb03$var$i18n.calendarsTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7x0As.MenuLinkItem), {
        href: (0, $1NBp8.SPACE_CALENDARS).toUrl({
            spaceKey: spaceKey
        }),
        onClick: onClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
            label: "",
            color: "currentColor"
        }),
        isSelected: isSelected,
        "data-vc": "team-calendar-navigation",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $544e89ef74bbdb03$var$i18n.calendars), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $61vzn.PremiumLozengeLoadable), null)));
};
const $544e89ef74bbdb03$var$isOnSCalendarsRoute = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_CALENDARS).name || routeName === (0, $1NBp8.SPACE_CALENDARS_SUBCALENDAR).name
};
const $544e89ef74bbdb03$var$i18n = (0, $2nPZH.defineMessages)({
    calendarsTooltip: {
        id: "side-navigation.space-navigation.calendars.tooltip",
        defaultMessage: "View calendar"
    },
    calendars: {
        id: "side-navigation.space-navigation.calendars",
        defaultMessage: "Calendars"
    }
});

});
parcelRegister("61vzn", function(module, exports) {

$parcel$export(module.exports, "TrialFlags", () => $5e8e088fe72e4df1$export$c108f21945b8b79);
$parcel$export(module.exports, "PremiumLozengeLoadable", () => $5e8e088fe72e4df1$export$62673719cbe80cd0);
$parcel$export(module.exports, "LazyAutoUpgradeAwarenessModal", () => $5e8e088fe72e4df1$export$212b4f568257f60f);
$parcel$export(module.exports, "ReverseTrialLozengeExperiment", () => $5e8e088fe72e4df1$export$b51195909514673e);
$parcel$export(module.exports, "PremiumLozengeImage", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("leRtl")))));
$parcel$export(module.exports, "useGetUserCount", () => (parcelRequire("dyQkx")).useGetUserCount);

var $gwFzn = parcelRequire("gwFzn");

var $dIouf = parcelRequire("dIouf");

var $jmjWc = parcelRequire("jmjWc");

var $leRtl = parcelRequire("leRtl");

var $dyQkx = parcelRequire("dyQkx");

const $5e8e088fe72e4df1$var$TrialFlagsLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pBDfE",
    name: "TrialFlagsLoadable",
    loader: async ()=>(await (parcelRequire("hfSv4"))).TrialFlags
});
const $5e8e088fe72e4df1$export$c108f21945b8b79 = (0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).GROWTH_LUNA
})(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5e8e088fe72e4df1$var$TrialFlagsLoadable, null));

const $5e8e088fe72e4df1$export$62673719cbe80cd0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Txnkb",
    name: "PremiumLozengeLoadable",
    loader: async ()=>(await (parcelRequire("lhVPO"))).PremiumLozenge
});

const $5e8e088fe72e4df1$export$212b4f568257f60f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "E5jvU",
    name: "LazyAutoUpgradeAwarenessModal",
    loader: async ()=>(await (parcelRequire("4R0Br"))).AutoUpgradeAwarenessModal
});

const $5e8e088fe72e4df1$export$b51195909514673e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EHgbD",
    name: "ReverseTrialLozengeExperiment",
    loader: async ()=>(await (parcelRequire("eeA8N"))).ReverseTrialLozenge
});

});
parcelRegister("leRtl", function(module, exports) {
module.exports = new URL("premiumLozenge.aa9b0435.svg", import.meta.url).toString();

});

parcelRegister("dyQkx", function(module, exports) {

$parcel$export(module.exports, "useGetUserCount", () => $67f403c91a6578ae$export$5106bd0c428c7535);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $xQxzY = parcelRequire("xQxzY");

var $7Sm4c = parcelRequire("7Sm4c");
const $67f403c91a6578ae$export$5106bd0c428c7535 = ()=>{
    const { data: data, error: error, loading: loading } = (0, $xQxzY.useQuery)((0, $d2LG0.default)`query useGetUserCountNumberOfUsersInvitedQuery{license{licenseConsumingUserCount}}`, {
        fetchPolicy: 'cache-and-network'
    });
    if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    return {
        error: error,
        loading: loading,
        userCount: data?.license?.licenseConsumingUserCount
    };
};

});

parcelRegister("hfSv4", function(module, exports) {

let $c8fe1cfbeff454a9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c8fe1cfbeff454a9$var$load("cmcKh"),
    $c8fe1cfbeff454a9$var$load("ktyyJ")
]).then(()=>parcelRequire('1VYG6'));

});

parcelRegister("lhVPO", function(module, exports) {

let $f7f80c459b873240$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f7f80c459b873240$var$load("4yUSc").then(()=>parcelRequire('9xi4O'));

});

parcelRegister("4R0Br", function(module, exports) {

let $388c94659c0645ac$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $388c94659c0645ac$var$load("4fCJZ"),
    $388c94659c0645ac$var$load("dTsOE"),
    $388c94659c0645ac$var$load("x8U2P")
]).then(()=>parcelRequire('6yR7w'));

});

parcelRegister("eeA8N", function(module, exports) {

let $a5ce6850d4a06c24$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a5ce6850d4a06c24$var$load("fqBFU").then(()=>parcelRequire('gQsLh'));

});




//# sourceMappingURL=CalendarsLink.cb156c6e.js.map
